import React, { useState, useEffect, useMemo } from "react";
import CustomInput from "./common/CustomInput";
import CustomSelect from "./common/CustomSelect";
import CustomHeading from "./common/CustomHeading";
import Button from "./common/Button";
import { Trash2, CheckCircle } from "lucide-react";
import Uploadpopup from "./FinancialAnalysis/Uploadpopup";
import CreditBureauReport from "./FinancialAnalysis/Creditbureaureport";
import {
  saveCreditProfile,
  getKycVerificationByUserIdNew,
  fetchCrifReportHtml,
} from "../ActionCreator";

const FourthSection = ({
  allDetail,
  initialData,
  individualKycData,
  setLoader,
  showPopup,
  onRefresh,
  admin,
}) => {
  const [form, setForm] = useState({
    partners: [{ type: "", name: "", designation: "", shareholding: "", userId: "" }],
    creditProfiles: [],
    overallAssessment: "",
    pfEsiDate: "",
    pfEsiRemark: "",
    pfEsiStatus: "",
    mcaDate: "",
    mcaRemark: "",
    mcaStatus: "",
    gstStatus: "",
    gstDate: "",
    gstRemark: "",
    udyam: false,
    udyamNo: "",
    tradeLicense: false,
    tradeLicenseNo: "",
    otherApprovals: false,
    otherApprovalsNo: "",
    taxLitigation: "",
    bankingArbitration: "",
    civilCriminalCases: "",
  });

  const [btnLoading, setBtnLoading] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const [Openbureau, setOpenbureau] = useState(false);
  const [customBureau, setcustomBureau] = useState({});
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [popup, setshowPopup] = useState({ show: false, data: {} });
  const [localIndividualKycData, setLocalIndividualKycData] = useState(null);
  const [openCrifPopup, setOpenCrifPopup] = useState(false);
  const [crifHtml, setCrifHtml] = useState("");
  const [crifLoading, setCrifLoading] = useState(false);
  const [crifUserName, setCrifUserName] = useState("");

  const partners = form.partners ?? [
    { type: "", name: "", designation: "", shareholding: "", userId: "" },
  ];
  const creditProfiles = form.creditProfiles ?? [];

  // Sync state with parent-supplied initialData
  useEffect(() => {
    if (initialData) {
      setForm({
        partners: initialData.partners ?? [{ type: "", name: "", designation: "", shareholding: "", userId: "" }],
        creditProfiles: initialData.creditProfiles ?? [],
        overallAssessment: initialData.overallAssessment ?? "",
        pfEsiDate: initialData.pfEsiDate ?? "",
        pfEsiRemark: initialData.pfEsiRemark ?? "",
        pfEsiStatus: initialData.pfEsiStatus ?? "",
        mcaDate: initialData.mcaDate ?? "",
        mcaRemark: initialData.mcaRemark ?? "",
        mcaStatus: initialData.mcaStatus ?? "",
        gstStatus: initialData.gstStatus ?? "",
        gstDate: initialData.gstDate ?? "",
        gstRemark: initialData.gstRemark ?? "",
        udyam: initialData.udyam ?? false,
        udyamNo: initialData.udyamNo ?? "",
        tradeLicense: initialData.tradeLicense ?? false,
        tradeLicenseNo: initialData.tradeLicenseNo ?? "",
        otherApprovals: initialData.otherApprovals ?? false,
        otherApprovalsNo: initialData.otherApprovalsNo ?? "",
        taxLitigation: initialData.taxLitigation ?? "",
        bankingArbitration: initialData.bankingArbitration ?? "",
        civilCriminalCases: initialData.civilCriminalCases ?? "",
      });
    }
  }, [initialData]);

  const handleChange = (e, field) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleDirectLy = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleRowChange = (index, field, value, type) => {
    if (type === "promoter") {
      const updated = [...partners];
      updated[index][field] = value;
      setForm((prev) => ({ ...prev, partners: updated }));
    } else {
      const updated = [...creditProfiles];
      updated[index][field] = value;
      setForm((prev) => ({ ...prev, creditProfiles: updated }));
    }
  };

  const addPromoterRow = () => {
    const updated = [
      ...partners,
      { type: "", name: "", designation: "", shareholding: "", userId: "" },
    ];
    setForm((prev) => ({ ...prev, partners: updated }));
  };

  const deletePromoterRow = (index) => {
    if (partners.length === 1) return;
    const updated = partners.filter((_, i) => i !== index);
    setForm((prev) => ({ ...prev, partners: updated }));
  };

  const addCreditRow = () => {
    const updated = [
      ...creditProfiles,
      {
        type: "PRIMARY",
        name: "",
        cibil: "",
        balance: "",
        emi: "",
        defaults: "",
        remark: "",
        userId: "",
        docPath: "",
      },
    ];
    setForm((prev) => ({ ...prev, creditProfiles: updated }));
  };

  const deleteCreditRow = (index) => {
    const updated = creditProfiles.filter((_, i) => i !== index);
    setForm((prev) => ({ ...prev, creditProfiles: updated }));
  };

  const fetchCustomBureau = (userId) => {
    setLoader(true);
    // getStateForBureauByUserId(userId, (callback) => {
    //   getBureauReportData(
    //     callback?.data?.transaction?.clientTransactionId,
    //     (res) => {
    //       setLoader(false);
    //       setcustomBureau(res ?? {});
    //     },
    //   );
    // });
  };

  const allIndividuals = useMemo(() => {
    if (!individualKycData) return [];
    const roles = ["BORROWER", "COBORROWER", "GUARANTOR", "DIRECTOR"];
    return roles.flatMap((role) =>
      Array.isArray(individualKycData[role])
        ? individualKycData[role].map((item) => ({
          fullName: item?.fullName || "",
          userId: item?.userId || "",
        }))
        : []
    );
  }, [individualKycData]);

  const handleViewBureau = (profile) => {
    console.log("profile", profile);
    const matched = allIndividuals.find(
      (p) => p.fullName?.toLowerCase() === profile.name?.toLowerCase()
    );
    const userId = matched?.userId || "";
    setSelectedProfile(profile);
    setOpenbureau(true);
    fetchCustomBureau(userId);
  };

  const handleViewCrif = (profile) => {
    const matched = allIndividuals.find(
      (p) => p.fullName?.toLowerCase() === profile.name?.toLowerCase()
    );
    const userId = matched?.userId || profile.userId || "";
    if (!userId) {
      showPopup("User ID not found for this profile");
      return;
    }

    setCrifUserName(profile.name || "");
    setOpenCrifPopup(true);
    setCrifLoading(true);
    setCrifHtml("");

    fetchCrifReportHtml(userId, "0", "", admin?.emailId, (res) => {
      setCrifLoading(false);
      if (res && res.trim() && !res.includes("error") && !res.includes("not found")) {
        setCrifHtml(res);
      } else {
        setCrifHtml("<h5 style='padding: 40px; text-align: center; color: #ef4444;'>No CRIF report found for this user</h5>");
      }
    });
  };

  const statutoryRows = [
    {
      label: "GST Returns",
      statusKey: "gstStatus",
      dateKey: "gstDate",
      remarkKey: "gstRemark",
    },
    {
      label: "MCA Compliances",
      statusKey: "mcaStatus",
      dateKey: "mcaDate",
      remarkKey: "mcaRemark",
    },
    {
      label: "PF/ESI",
      statusKey: "pfEsiStatus",
      dateKey: "pfEsiDate",
      remarkKey: "pfEsiRemark",
    },
  ];

  const additionalKYC = [
    {
      label: "Trade License",
      key: "tradeLicense",
      licenseKey: "tradeLicenseNo",
    },
    { label: "Udyam", key: "udyam", licenseKey: "udyamNo" },
    {
      label: "Other Statutory Approvals",
      key: "otherApprovals",
      licenseKey: "otherApprovalsNo",
    },
  ];

  useEffect(() => {
    if (individualKycData && Object.keys(individualKycData).length > 0) {
      setLocalIndividualKycData(individualKycData);
      return;
    }

    const userId = allDetail?.userId || allDetail?.loanId;
    if (!userId) return;

    setLoader(true);
    getKycVerificationByUserIdNew(userId, (callback) => {
      setLoader(false);
      if (callback && callback.data) {
        setLocalIndividualKycData(callback.data);
      }
    });
  }, [individualKycData, allDetail]);



  useEffect(() => {
    if (!localIndividualKycData) return;

    const savedProfiles = localIndividualKycData.creditProfiles;
    if (Array.isArray(savedProfiles) && savedProfiles.length > 0) {
      const mappedProfiles = savedProfiles.map((row) => ({
        id: row.id,
        type: row.applicantType || "PRIMARY",
        name: row.name || "",
        cibil: row.crifScore || "",
        balance: row.existingLoanBalance !== undefined ? row.existingLoanBalance : "",
        emi: row.existingEmi !== undefined ? row.existingEmi : "",
        defaults: row.pastDefaults || "",
        remark: row.remarks || "",
        docPath: row.docPath || "",
        userId: row.userId || "",
        loanId: row.loanId || ""
      }));
      setForm((prev) => ({
        ...prev,
        overallAssessment: localIndividualKycData.overallAssessment || prev.overallAssessment,
        creditProfiles: mappedProfiles
      }));
    } else {
      const rolesMapping = {
        BORROWER: "PRIMARY",
        COBORROWER: "CO_APPLICANT",
        GUARANTOR: "GUARANTOR",
        DIRECTOR: "DIRECTOR",
        PARTNER: "PARTNER",
        PROPRIETOR: "PROPRIETOR"
      };

      let applicants = [];

      Object.keys(rolesMapping).forEach((role) => {
        const items = localIndividualKycData[role];
        if (Array.isArray(items)) {
          const mapped = items.map((item) => ({
            name: item?.fullName || "",
            cibil: "",
            dod: "",
            loanType: "",
            balance: "",
            emi: "",
            defaults: "",
            remark: "",
            userId: item?.userId || "",
            type: rolesMapping[role] || role,
          }));

          applicants.push(...mapped);
        }
      });

      if (applicants.length) {
        handleDirectLy("creditProfiles", applicants);
      }
    }
  }, [localIndividualKycData]);

  const handlePopup = (value, data) => {
    setshowPopup({ show: value, data: data });
  };

  const handleSave = () => {
    setBtnLoading(true);

    const activeLoanId = allDetail?.loanId;
    const activeUserId = allDetail?.userId;

    const creditProfilePayload = {
      loanId: activeLoanId,
      userId: activeUserId,
      overallAssessment: form.overallAssessment || "",
      creditProfiles: creditProfiles.map((row, index) => ({
        id: row.id || (index + 1),
        applicantType: row.type || "PRIMARY",
        name: row.name || "",
        crifScore: row.cibil || "",
        existingLoanBalance: row.balance ? parseFloat(row.balance) : 0.00,
        existingEmi: row.emi ? parseFloat(row.emi) : 0.00,
        pastDefaults: row.defaults || "",
        remarks: row.remark || "",
        docPath: row.docPath || ""
      }))
    };

    saveCreditProfile(
      creditProfilePayload,
      (creditRes) => {
        setBtnLoading(false);
        const resData = creditRes?.data || creditRes;
        if (creditRes && (creditRes.status === 200 || creditRes.success === true || resData?.status === 200)) {
          showPopup("Credit Profile saved successfully");

          setLoader(true);
          getKycVerificationByUserIdNew(activeUserId, (callback) => {
            setLoader(false);
            if (callback && callback.data) {
              setLocalIndividualKycData(callback.data);
            }
          });
        } else {
          showPopup(creditRes?.message || "Error saving credit profile");
        }
      },
      (err) => {
        setBtnLoading(false);
        showPopup("Error saving credit profile");
        console.error("Error saving credit profile", err);
      }
    );
  };

  return (
    <div style={{ marginTop: "12px" }}>
      <CustomHeading
        title="Management and Promoter Profile"
        subtitle="Details of all directors partners and promoters"
        buttonText="Positive"
        icon={CheckCircle}
        buttonColor="#4CAF50"
        borderColor="#E70E89"
        background="#E70E891A"
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        <Button
          title="Save Data"
          onClick={handleSave}
          btnLoading={btnLoading}
        />
      </div>

      <div style={{ background: "#F9FAFB", display: "flex", flexDirection: "column", gap: "12px" }}>
        {/* ── Promoter / Director / Partner Details ── */}
        {/* <div style={card}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <h5 style={{ ...sectionTitle, color: "#e91e8c" }}>
              Promoter / Director / Partner Details
            </h5>
            <button style={addBtn} onClick={addPromoterRow}>
              + Add Person
            </button>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table style={tableBase}>
              <thead>
                <tr>
                  {[
                    "Type",
                    "Name",
                    "Designation",
                    "Shareholding(%)",
                    "Action",
                  ].map((h) => (
                    <th key={h} style={th}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {partners.map((row, i) => (
                  <tr key={i}>
                    <td style={td}>
                      <CustomSelect
                        value={row.type}
                        onChange={(e) =>
                          handleRowChange(i, "type", e.target.value, "promoter")
                        }
                        options={[
                          { label: "Select", value: "" },
                          { label: "Promoter", value: "promoter" },
                          { label: "Director", value: "director" },
                          { label: "Partner", value: "partner" },
                        ]}
                      />
                    </td>

                    <td style={td}>
                      <CustomInput
                        value={row.name}
                        onChange={(e) =>
                          handleRowChange(i, "name", e.target.value, "promoter")
                        }
                      />
                    </td>

                    <td style={td}>
                      <CustomInput
                        value={row.designation}
                        onChange={(e) =>
                          handleRowChange(
                            i,
                            "designation",
                            e.target.value,
                            "promoter",
                          )
                        }
                      />
                    </td>

                    <td style={td}>
                      <CustomInput
                        type="number"
                        value={row.shareholding}
                        onChange={(e) =>
                          handleRowChange(
                            i,
                            "shareholding",
                            e.target.value,
                            "promoter",
                          )
                        }
                      />
                    </td>
                    <td style={td}>
                      {partners.length > 1 && (
                        <button
                          onClick={() => deletePromoterRow(i)}
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            color: "#e53935",
                          }}
                        >
                          <Trash2 size={16} />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div> */}

        <div style={{ ...card }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <h5 style={{ ...sectionTitle, color: "#e91e8c" }}>
              Credit Profile of Individuals
            </h5>
            <button style={addBtn} onClick={addCreditRow}>
              + Add Row
            </button>
          </div>
          <div
            style={{
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <table style={tableBase}>
              <thead>
                <tr>
                  {[
                    "Applicant Type",
                    "Name",
                    "CRIF Score",
                    "Existing Loan Balance(₹)",
                    "Existing EMI (₹)",
                    "Past Defaults",
                    "Remarks",
                    "Action",
                  ].map((h) => (
                    <th key={h} style={th}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {creditProfiles.map((row, i) => (
                  <tr key={i}>
                    <td style={{ ...td, minWidth: "130px" }}>
                      <CustomSelect
                        value={row.type}
                        onChange={(e) =>
                          handleRowChange(i, "type", e.target.value, "credit")
                        }
                        options={[
                          { label: "Select", value: "" },
                          { label: "Borrower", value: "PRIMARY" },
                          { label: "Co-Borrower", value: "CO_APPLICANT" },
                          { label: "Guarantor", value: "GUARANTOR" },
                          { label: "Director", value: "DIRECTOR" },
                        ]}
                      />
                    </td>
                    <td style={{ ...td, minWidth: "130px" }}>
                      <CustomInput
                        value={row.name}
                        onChange={(e) =>
                          handleRowChange(i, "name", e.target.value, "credit")
                        }
                      />
                    </td>

                    <td style={{ ...td, minWidth: "130px" }}>
                      <CustomInput
                        type="number"
                        value={row.cibil}
                        onChange={(e) =>
                          handleRowChange(i, "cibil", e.target.value, "credit")
                        }
                      />
                    </td>

                    <td style={{ ...td, minWidth: "130px" }}>
                      <CustomInput
                        type="number"
                        value={row.balance}
                        onChange={(e) =>
                          handleRowChange(i, "balance", e.target.value, "credit")
                        }
                      />
                    </td>

                    <td style={{ ...td, minWidth: "130px" }}>
                      <CustomInput
                        type="number"
                        value={row.emi}
                        onChange={(e) =>
                          handleRowChange(i, "emi", e.target.value, "credit")
                        }
                      />
                    </td>

                    <td style={{ ...td, minWidth: "130px" }}>
                      <CustomInput
                        value={row.defaults}
                        onChange={(e) =>
                          handleRowChange(i, "defaults", e.target.value, "credit")
                        }
                      />
                    </td>

                    <td style={{ ...td, minWidth: "130px" }}>
                      <CustomInput
                        value={row.remark}
                        onChange={(e) =>
                          handleRowChange(i, "remark", e.target.value, "credit")
                        }
                      />
                    </td>
                    <td style={td}>
                      <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                        <button
                          style={addBtn}
                          onClick={() => {
                            handleViewCrif(creditProfiles[i]);
                          }}
                        >
                          View
                        </button>
                        <button
                          onClick={() => deleteCreditRow(i)}
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            color: "#e53935",
                          }}
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Overall Management Assessment ── */}
        <div style={{ ...card }}>
          <h5 style={{ ...sectionTitle, color: "#e91e8c" }}>
            Overall Management Assessment
          </h5>
          <div style={{ marginTop: "14px" }}>
            <CustomInput
              label="Overall Assessment"
              type="textarea"
              placeholder="Provide overall assessment of the management team..."
              value={form.overallAssessment || ""}
              onChange={(e) => handleChange(e, "overallAssessment")}
              rows={4}
            />
          </div>
        </div>


      </div>

      {Openbureau ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.45)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              width: "calc(100vw - 100px)",
              height: "calc(100vh - 200px)",
              padding: "24px",
              backgroundColor: "#fff",
              borderRadius: "12px",
              position: "relative",
              boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
            }}
          >
            <span
              onClick={() => {
                setOpenbureau(false);
                setSelectedProfile(null);
              }}
              style={{
                position: "absolute",
                top: "12px",
                right: "16px",
                cursor: "pointer",
                fontSize: "20px",
                color: "#6b7280",
                lineHeight: 1,
              }}
            >
              ✕
            </span>
            {customBureau && Object.keys(customBureau).length > 0 ? (
              <div
                style={{
                  overflowY: "auto",
                  height: "calc(100% - 60px)",
                  marginTop: "20px",
                }}
              >
                <CreditBureauReport bureauData={customBureau} />
              </div>
            ) : (
              <h5>{customBureau?.message ?? ""}</h5>
            )}
          </div>
        </div>
      ) : (
        ""
      )}

      {openCrifPopup ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(15, 23, 42, 0.45)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              width: "calc(100vw - 80px)",
              height: "calc(100vh - 120px)",
              padding: "24px",
              backgroundColor: "#fff",
              borderRadius: "16px",
              position: "relative",
              boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e2e8f0",
                paddingBottom: "12px",
                marginBottom: "16px",
              }}
            >
              <h4 style={{ margin: 0, color: "#1e293b", fontWeight: "600" }}>
                CRIF Bureau Report - {crifUserName}
              </h4>
              <span
                onClick={() => {
                  setOpenCrifPopup(false);
                  setCrifHtml("");
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  color: "#64748b",
                  fontWeight: "600",
                }}
              >
                ✕
              </span>
            </div>

            {crifLoading ? (
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                <div className="spinner-border text-primary" role="status" style={{ color: "#0d7a6e" }}>
                  <span className="sr-only">Loading CRIF Report...</span>
                </div>
                <p style={{ color: "#64748b", margin: 0 }}>Fetching report from bureau, please wait...</p>
              </div>
            ) : (
              <div
                style={{
                  overflowY: "auto",
                  flex: 1,
                  paddingRight: "4px",
                }}
                dangerouslySetInnerHTML={{ __html: crifHtml }}
              ></div>
            )}
          </div>
        </div>
      ) : (
        ""
      )}

      {popup?.show ? (
        <Uploadpopup
          open={popup?.show}
          onClose={() => handlePopup(false, {})}
          allDetail={popup?.data}
          setLoader={setLoader}
          showborrowerOnly={false}
          showCredit={false}
        />
      ) : (
        ""
      )}
    </div>
  );
};

// ── Shared styles ──────────────────────────────────────────
const card = {
  background: "rgba(255, 255, 255, 0.95)",
  border: "1px solid #cbd5e1",
  borderRadius: "16px",
  padding: "20px",
  boxShadow: "0 4px 20px -2px rgba(15, 23, 42, 0.04), 0 2px 8px -1px rgba(15, 23, 42, 0.02)",
};
const sectionTitle = {
  fontSize: "16px",
  fontWeight: "600",
  margin: "0 0 6px 0",
};
const subHeading = {
  fontSize: "14px",
  fontWeight: "600",
  color: "#334155",
  margin: "0 0 8px 0",
};
const tableBase = {
  width: "100%",
  borderCollapse: "separate",
  borderSpacing: "0 4px",
  fontSize: "13px",
};
const th = {
  padding: "11px 14px",
  textAlign: "left",
  fontWeight: "600",
  color: "#334155",
  fontSize: "12px",
  background: "#f1f5f9",
  borderBottom: "1.5px solid #cbd5e1",
};
const td = { padding: "10px 14px", color: "#0f172a", fontSize: "12px" };
const addBtn = {
  background: "#024e5a",
  color: "#fff",
  border: "none",
  borderRadius: "10px",
  padding: "8px 16px",
  fontSize: "13px",
  fontWeight: "600",
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "all 0.15s ease",
  outline: "none",
};

export default FourthSection;
